import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { textTranslation, shouldTranslateTo } from '../utils/utils'
import { decode } from 'html-entities'

export default class CookiePolicy extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cookiePolicyData: null,
    }
  }

  componentDidMount() {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })
          this.setState({
            cookiePolicyData: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('cookie-policy', language)
  }

  render() {
    if (!this.state.cookiePolicyData) {
      return null
    }
    return (
      <section id="privacyPolicy" className="contact-wrapper main-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-12 offset-md-2 col-md-8 text-left pt-4">
              <h2 className="title text-dark-green pb-4">
                {decode(this.state.cookiePolicyData[0])}
              </h2>
              <div
                className="text-justify"
                dangerouslySetInnerHTML={{
                  __html: decode(this.state.cookiePolicyData[1]),
                }}
              ></div>
              <div className="pt-2 pt-md-5">
                <Link
                  to="/signup"
                  className="btn btn-block btn-join text-decoration-none py-2"
                >
                  {decode(this.state.cookiePolicyData[2])}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
